<div xmlns="http://www.w3.org/1999/html">

    <mat-expansion-panel class="light-flex-card tv-mat-expansion-indicator-light-bg">
        <mat-expansion-panel-header>
            <mat-panel-title class="sub-title">
                Négociations Thématiques
            </mat-panel-title>
        </mat-expansion-panel-header>
        <!-- GUARANTEE -->
        <div class="container">
            <div class="item-all-content">
                <h4 class="guarantee-title">Achat garanti</h4>
                <div class="buttons-container">
                    <button (click)="openThemaPackModal()"
                            class="tv-round-icon-button-icon-small-light-blue margin">
                        <mat-icon>settings</mat-icon>
                    </button>
                    <button (click)="openThemaNegoModal('guarantee')"
                            class="tv-round-icon-button-icon-small-light-blue margin">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>

            <!--  INFO : themaNegotiationList[0] always guaranteed negotiation (see in contractItem.model.ts) -->
            <div class="item" *ngFor="let guaranteedNegotiation of themaNegotiationList[0]">
                <div class="item-content">
                    <div class="item-header-and-conditions">
                        <!-- Header -->
                        <div class="item-header">
                            <span class="targetId"> {{ guaranteedNegotiation.target.id }} </span>
                            <span class="targetLabel"> {{ guaranteedNegotiation.target.name }} </span>
                            <span class="date-range"> {{ guaranteedNegotiation.startDate }}
                                - {{ guaranteedNegotiation.endDate }} </span>
                            <span class="value"> {{ guaranteedNegotiation.value?.toLocaleString('fr-FR') }} € </span>
                            <span class="nctRate"> {{ guaranteedNegotiation.nctRate }} %</span>
                            <span class="packLabel"> {{ guaranteedNegotiation.contractPack?.label }} </span>
                        </div>

                        <!-- Conditions and Channels Conditions -->
                        <!-- Channels -->
                        <div class="item-channels-condition">
                            <ng-container *ngFor="let channelCondition of guaranteedNegotiation.channelConditions">
                                <div class="channel-condition-value">
                                    <img class="channel-logo" src="{{ channelCondition.channel.logo }}" alt="logo"/>

                                    <span> {{ channelCondition.rate || 0}} % </span>
                                </div>
                            </ng-container>
                        </div>

                        <!-- Conditions -->
                        <div class="item-conditions-value">
                            <mat-icon *ngIf="guaranteedNegotiation.conditions[0]?.isInclude === 1 "
                                      class="option-type-icon"
                                      svgIcon="add-circle-fill"></mat-icon>
                            <mat-icon *ngIf="guaranteedNegotiation.conditions[0]?.isInclude === 0"
                                      class="option-type-icon"
                                      svgIcon="delete-circle-fill"></mat-icon>
                            <div class="option-condition-value">
                                <ng-container *ngFor="let condition of guaranteedNegotiation.conditions">
                                    <span> {{condition.categoryValue?.labelCategoryValue }}
                                        ({{ condition.categoryValue?.idCategoryValue }}
                                        ) - </span>
                                </ng-container>
                            </div>
                        </div>
                    </div>

                    <div class="item-actions">
                        <mat-icon svgIcon="edit"
                                  (click)="openThemaNegoModal('guarantee', guaranteedNegotiation, false)"></mat-icon>
                        <mat-icon svgIcon="content-copy"
                                  (click)="openThemaNegoModal('guarantee', guaranteedNegotiation, true)"></mat-icon>
                        <mat-icon svgIcon="delete-bin"
                                  (click)="removeThemaNegotiation(guaranteedNegotiation)"></mat-icon>
                    </div>
                </div>
            </div>

        </div>

        <br>

        <!-- NOT GUARANTEE -->
        <div class="container">
            <div class="item-all-content">
                <h4 class="guarantee-title">Achat non garanti</h4>
                <button (click)="openThemaNegoModal('notGuarantee')"
                        class="tv-round-icon-button-icon-small-light-blue margin create-buttons">
                    <mat-icon>add</mat-icon>
                </button>
            </div>

            <!-- INFO : themaNegotiationList[1] always not guaranteed negotiation (see in contractItem.model.ts) -->
            <div class="item" *ngFor="let notGuaranteedNegotiation of themaNegotiationList[1]">
                <div class="item-content">
                    <div class="item-header-and-conditions">
                        <!-- Header -->
                        <div class="item-header">
                            <!--                            <span class="targetId"> {{ notGuaranteedNegotiation.target.id }} </span>-->
                            <!--                            <span class="targetLabel"> {{ notGuaranteedNegotiation.target.name }} </span>-->
                            <!--                            <span class="targetId"> - </span>-->
                            <!--                            <span class="targetLabel"> - </span>-->
                            <span class="date-range"> {{ notGuaranteedNegotiation.startDate }}
                                - {{ notGuaranteedNegotiation.endDate }} </span>
                            <span class="value"> {{ notGuaranteedNegotiation.value?.toLocaleString('fr-FR') }} € </span>

                            <!--                            <span class="value"> - </span>-->
                            <span class="nctRate"> {{ notGuaranteedNegotiation.nctRate }} %</span>
                            <!--                            <span class="packLabel"> - </span>-->
                        </div>

                        <!-- Conditions and Channels Conditions -->
                        <!-- Channels -->
                        <div class="item-channels-condition">
                            <ng-container *ngFor="let channelCondition of notGuaranteedNegotiation.channelConditions">
                                <div class="channel-condition-value">
                                    <div>
                                        <img class="channel-logo" src="{{ channelCondition.channel.logo }}" alt="logo"/>
                                    </div>
                                    <div>
                                        <span> {{ channelCondition.rate || 0 }} % </span>
                                    </div>
                                </div>
                            </ng-container>
                        </div>

                        <!-- Conditions -->
                        <div class="item-conditions-value">
                            <mat-icon *ngIf="notGuaranteedNegotiation.conditions[0]?.isInclude === 1 "
                                      class="option-type-icon"
                                      svgIcon="add-circle-fill"></mat-icon>
                            <mat-icon *ngIf="notGuaranteedNegotiation.conditions[0]?.isInclude === 0"
                                      class="option-type-icon"
                                      svgIcon="delete-circle-fill"></mat-icon>
                            <div class="option-condition-value">
                                <ng-container *ngFor="let condition of notGuaranteedNegotiation.conditions">
                                    <span> {{condition.categoryValue?.labelCategoryValue }}
                                        ({{ condition.categoryValue?.idCategoryValue }}
                                        ) - </span>
                                </ng-container>
                            </div>
                        </div>
                    </div>

                    <div class="item-actions">
                        <mat-icon svgIcon="edit"
                                  (click)="openThemaNegoModal('notGuarantee', notGuaranteedNegotiation, false)"></mat-icon>
                        <mat-icon svgIcon="content-copy"
                                  (click)="openThemaNegoModal('notGuarantee', notGuaranteedNegotiation, true)"></mat-icon>
                        <mat-icon svgIcon="delete-bin"
                                  (click)="removeThemaNegotiation(notGuaranteedNegotiation)"></mat-icon>
                    </div>
                </div>
            </div>
        </div>
    </mat-expansion-panel>

</div>
